<div class="data-sect">
    <h3 *ngIf="type">{{ type }} List</h3>
    <hr>
    <mat-accordion *ngIf="data && data.length > 0">
        <mat-expansion-panel
            *ngFor="let item of data"
            class="margin-bottom-20"
            (opened)="panelMap[item?.id] = true"
            (closed)="panelMap[item?.id] = false"
            [expanded]="panelMap[item?.id]"
        >
            <mat-expansion-panel-header class="mat-expansion-panel-header--auto">
                <div class="list-item width-stretch">
                    <div class="list-item-content">
                        <h4 class="margin-bottom-10">{{ item.title }}</h4>
                        <div class="pipe-separated-list margin-bottom-10">
                            <div class="pipe-separated-list">
                                <a
                                    [href]="item.imagePath"
                                    target="_blank"
                                    *ngIf="item.imagePath"
                                >
                                    View Image
                                </a>
                                <a
                                    [href]="item.video"
                                    target="_blank"
                                    *ngIf="item.video"
                                >
                                    View Video or Link
                                </a>
                                <a
                                    [href]="item.pdfUrl"
                                    target="_blank"
                                    *ngIf="item.pdfUrl"
                                >
                                    View PDF
                                </a>

                                <a *ngIf="enableCeoSpecificFields" href="javascript:void(0)" (click)="onUploadThumbnail($event, item)">
                                    Upload Thumbnail
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="list-item-action">
                        <ng-template [ngIf]="panelMap[item?.id]">
                            <button mat-icon-button type="button" (click)="pin(item)" *ngIf="enableCeoSpecificFields">
                                <span *ngIf="!item.feature">Pin</span>
                                <span *ngIf="item.feature">Unpin</span>
                            </button>
                            <button
                                mat-icon-button
                                type="button"
                                (click)="onEdit(item)"
                            >
                                <img
                                    src="assets/images/Edit.png"
                                    alt="Edit"
                                >
                            </button>
                            <button
                                class="margin-right-10"
                                mat-icon-button
                                type="button"
                                (click)="deleteData(item)"
                            >
                                <img
                                    src="assets/images/Delete.png"
                                    alt="Delete"
                                >
                            </button>
                        </ng-template>
                    </div>
                </div>
            </mat-expansion-panel-header>
            <ng-template [ngIf]="enableCeoSpecificFields">
                <p>Year - {{item.year}}, Month - {{item.month}}</p>
                <p>{{item.shortDesc}}</p>
            </ng-template>
            <p [innerHTML]="item.htmlContent"></p>
        </mat-expansion-panel>
    </mat-accordion>



    <div *ngIf="data?.length === 0 && type">
        <p class="no-data">No data found</p>
    </div>
</div>
